import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import UploaderDesignerTool from "src/components/util/uploader-designer-tool";

const getAllImage = (content) => {
  const regexImg = /<img [^>]*>/gm;
  const regexSrcImg = /<img [^>]*src="([^"]*)"[^>]*>/;
  const regexWidthImg = /<img [^>]*width="([^"]*)"[^>]*>/;
  const regexHeightImg = /<img [^>]*height="([^"]*)"[^>]*>/;
  const imgs = content.match(regexImg);
  if (imgs && Array.isArray(imgs)) {
    const srcs = [];
    imgs.forEach((img) => {
      const [_, src] = regexSrcImg.exec(img) || [];
      const [_width, width] = regexWidthImg.exec(img) || [];
      const [_height, height] = regexHeightImg.exec(img) || [];
      srcs.push({
        src,
        width,
        height,
        element: img
      });
    });
    console.log(srcs);
    return srcs;
  }

  return [];
};

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
    columnGap: '1rem',
    rowGap: '1rem'
  },
  contentItem: {
    border: '0.5px dashed blue'
  }
}));

const ChangeContentPost = ({ post , updatePost}) => {
  const { content, content_m } = post;
  const [sources, setSources] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const srcs = getAllImage(content);
    setSources(srcs);
  }, [post]);

  const noneedcrop = (data, indexImg) => {
    const { url, width, height } = data;
    console.log(data);
    console.log("width", width);
    console.log("height", height);
    
    let element = sources[indexImg].element;
    element = element.replace(sources[indexImg].src, url);
    element = element.replace(`width="${sources[indexImg].width}"`, `width="${width}"`);
    element = element.replace(`height="${sources[indexImg].height}"`, `height="${height}"`);

    updatePost(post, {images: [sources[indexImg].src, url], width: [sources[indexImg].width, width], height: [sources[indexImg].height, height] , element: [sources[indexImg].element, element]});
  };
  return (
    <>
      <h4 className="mt-5">Ảnh trong nội dung bài viết</h4>
      <div className={classes.contentWrapper}>
        {sources.map((source, index )=> (
          <div className={classes.contentItem} key={`source-${post.id}-${index}`}>
            <UploaderDesignerTool
              tmp_id={post.tmp_id || post.id}
              dragagain={false}
              url={source.src}
              type="content"
              noneedcrop={(data) => noneedcrop(data, index)}
              no_crop={true}
              noRequireSize={true}
              post={post}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ChangeContentPost;
